import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import popup from '@/components/popup/index.vue'

// 新增：导入样式
import "quill/dist/quill.core.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false


Vue.directive('pullRefresh', {
    bind(el, binding) {
        let startY = 0
        let currentY = 0
        let isPulling = false
        const threshold = 80  // 触发刷新的下拉阈值

        el.addEventListener('touchstart', touchStart)
        el.addEventListener('touchmove', touchMove)
        el.addEventListener('touchend', touchEnd)
        el.addEventListener('mousedown', mouseDown)

        function touchStart(e) {
            if (el.scrollTop === 0) {
                startY = e.touches[0].pageY
                isPulling = true
            }
        }

        function touchMove(e) {
            if (!isPulling) return
            currentY = e.touches[0].pageY
            updatePull(e)
        }

        function mouseDown(e) {
            if (el.scrollTop === 0) {
                startY = e.pageY
                isPulling = true
                document.addEventListener('mousemove', mouseMove)
                document.addEventListener('mouseup', mouseUp)
            }
        }

        function mouseMove(e) {
            currentY = e.pageY
            updatePull(e)
        }

        function updatePull(e) {
            const deltaY = currentY - startY

            if (deltaY > 0) {
                e.preventDefault()
                el.style.transform = `translateY(${Math.min(deltaY, threshold)}px)`
            }
        }

        function touchEnd() {
            finishPull()
        }

        function mouseUp() {
            finishPull()
            document.removeEventListener('mousemove', mouseMove)
            document.removeEventListener('mouseup', mouseUp)
        }

        function finishPull() {
            if (parseInt(el.style.transform.slice(11)) >= threshold) {
                binding.value() // 执行刷新回调
            }
            el.style.transition = 'transform 0.3s'
            el.style.transform = 'translateY(0)'
            setTimeout(() => {
                el.style.transition = ''
                isPulling = false
            }, 300)
        }
    }
})
// main.js
Vue.directive('integer', {
    inserted(el) {
        el.addEventListener('input', (e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
        })
    }
})

Vue.component('popup', popup)
Vue.prototype.toJSON = () => {
    return this
}
Vue.prototype.roundDownToTwoDecimals = (value) => {
    let newValue = Number(value)
    return Math.ceil(newValue * 10000) / 10000
}
Vue.prototype.getTimeMin = (time) => {
    let t = new Date(time);
    let year = t.getFullYear();
    let month = t.getMonth() + 1; // 月份从0开始，所以要加1
    let day = t.getDate(); // 注意：使用getDate()获取日，getDay()获取的是星期几
    let hours = t.getHours();
    let minutes = t.getMinutes();
    let seconds = t.getSeconds();

    // 为了保证月份、分钟和秒都是两位数，使用padStart()方法
    month = month.toString().padStart(2, '0');
    day = day.toString().padStart(2, '0');
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    seconds = seconds.toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}


Vue.use(ElementUI);
new Vue({
    router,
    store,
    render: function (h) {
        return h(App)
    }
}).$mount('#app')
